module.exports = __webpack_public_path__ + "static/media/maxidi-logo.4555fd6b.svg";